export default __webpack_public_path__ + "static/media/icon-email.860f1a93.svg";